/**
 * Common enums shared across the contract boundary.
 * Kept as const arrays so both a union type and a runtime value list are available.
 */
/** User roles (users.role). */
export const USER_ROLES = ['user', 'admin'];
export const DEFAULT_USER_ROLE = 'user';
/** Survey answer types (surveys.answer_type) — single/multiple select. */
export const ANSWER_TYPES = ['single', 'multiple'];
/**
 * Image content types accepted for R2 upload signing.
 * The signed URL pins the content type, so the browser must PUT with the exact
 * value it requested.
 */
export const UPLOAD_CONTENT_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
];
/**
 * Upload purpose — namespaces the R2 object key by feature so assets are
 * grouped (e.g. articles/<YYYYMM>/<uuid>.<ext>). Optional on the sign request;
 * when absent the server falls back to the legacy per-user namespace.
 */
export const UPLOAD_KINDS = ['article', 'post'];
/**
 * Reaction value — a viewer's single reaction to a post or article. One row per
 * (user, target); 'like'(좋아요) XOR 'dislike'(싫어요). Shared by both pillars.
 */
export const REACTION_VALUES = ['like', 'dislike'];
/** Max image size accepted by the upload-signing endpoint. */
export const UPLOAD_MAX_BYTES = 5 * 1024 * 1024;
/**
 * PD 수첩 article lifecycle status (derived server-side):
 *   - 'draft'     — saved but not submitted (is_submitted=false); author-only.
 *   - 'pending'   — submitted, awaiting admin approval (is_submitted=true, is_active=false).
 *   - 'published' — admin-approved & public (is_active=true).
 */
export const ARTICLE_STATUSES = ['draft', 'pending', 'published'];
//# sourceMappingURL=enums.js.map